import { Box, Typography } from "@drone-js/core";
import { ToastErrorNotification } from "../urlInput/ToastErrorNotification";
import { ImportedSection } from "./ImportedSection";
import { ListingControls } from "./ListingControls";
import { ListingSection } from "./ListingSection";
import { Loader } from "./Loader";
import { NotificationEmptySelectedProperty } from "./NotificationEmptySelectedProperty";
import { ValidationError } from "./constants";
import { useAutomaticListsHandler } from "./useAutomaticListsHandler";
import { useScrapeProperties } from "./useScrapeProperties";

import "./overrides.css";
import { automaticListsBinder } from "libs/analytics/binders/propertySelection/automaticLists";
import { useAnalytics } from "libs/analytics/useAnalytics";
import { useParams } from "router";
import { Footer } from "../Footer";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";
import { useURLInputValue } from "../urlInput/urlInputAtom";

export const AutomaticListsPage = () => {
    const {
        automaticPropertySelectionCms: { pageTitle, genericErrorMessage },
        inputUrlCms: { errorOngoingImportDetected, listingsStillBeingImported, viewCurrentImportListings },
    } = usePropertySelectionViewModelValue();

    // url will be received from input atom at input page, but input page does not exist at the moment
    const inputUrl = useURLInputValue();
    const { loading } = useScrapeProperties(inputUrl);
    const { lang } = useParams("/:lang/list-my-property/get-started/automatic/lists");

    const { error, ...footerProps } = useAutomaticListsHandler();
    useAnalytics(automaticListsBinder);

    if (loading) return <Loader />;

    return (
        <Box pb="32" display="flex" flexDirection="column">
            <Box
                backgroundColor="base.surface"
                pt="32"
                pb="8"
                px="16"
                mx="-16"
                mb="8"
                position="sticky"
                // navbar height + top padding
                top={0}
                zIndex={999}
            >
                <Box qM={{ display: "flex", justifyContent: "space-between", alignItems: "end" }}>
                    <Typography variant="heading-xl" textColor="base.default">
                        {pageTitle}
                    </Typography>
                    <ListingControls />
                </Box>
                {error === ValidationError.EmptySelection && <NotificationEmptySelectedProperty />}
            </Box>
            <ListingSection />
            <ImportedSection />
            <Footer {...footerProps} />
            <ToastErrorNotification
                isOpen={error === ValidationError.InprogressExist || error === ValidationError.TechnicalIssue}
                title={error === ValidationError.InprogressExist ? errorOngoingImportDetected : null}
                content={error === ValidationError.InprogressExist ? listingsStillBeingImported : genericErrorMessage}
                actions={
                    error === ValidationError.InprogressExist
                        ? [
                              {
                                  label: viewCurrentImportListings,
                                  onClick: () => {
                                      window.location.assign(`/homes/${lang}/HostManage/#/listings/inprogress`);
                                  },
                              },
                          ]
                        : null
                }
            />
        </Box>
    );
};
